import {Layout, Typography, Divider, Image} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Paragraph, Text} = Typography;
const {Content} = Layout;

const CollaborationPart3 = () => {
  return (
    <Layout style={{margin: '80px 50px 50px 50px', background: 'inherit'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-4%'}}>Collaboration with iGEM UAM</Paragraph>
      <Text className='BaseText' style={{textAlign: 'justify', textJustify: 'inter-word'}}><Text className='BaseText'>With iGEM UAM, we collaborated on our social networks, where we made TikToks for both accounts and addressed relevant science topics such as energy drinks, cultured meat, and the human genome, among others. </Text></Text>
      <Content style={{display: 'block', maxWidth: '80%', marginLeft: 'auto', marginRight: 'auto', marginTop: '30px', background: 'inherit'}}>
        <Image.PreviewGroup>
          <Image width={'70%'} src='https://static.igem.wiki/teams/4464/wiki/team/collaborations/igem-uam-2.png'></Image>
          <Image width={'30%'} src='https://static.igem.wiki/teams/4464/wiki/team/collaborations/igem-uam-1.png'></Image>
        </Image.PreviewGroup>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CollaborationPart3;
